import { Point } from 'app/CornerstoneTools/types';
import { BaseAnnotation } from 'cornerstone-tools';
import { getEnabledElement, pixelToCanvas } from 'cornerstone-core';
import { mapValues } from 'lodash';
import normalizePoint from 'app/CornerstoneTools/utils/normalizePoint';

export default function normalizeHandlesInCanvas<T extends BaseAnnotation>(
  element: HTMLElement,
  annotation: T
) {
  return {
    ...annotation,
    handles: mapValues(annotation.handles, (handle: Point) => ({
      ...handle,
      ...normalizePoint(getEnabledElement(element).canvas, pixelToCanvas(element, handle as any)),
    })),
  };
}
